import { MARQUEE_ITEMS, IS_TAGS } from "@/data/brands";

export default function BrandMarquee() {
  const row = [...MARQUEE_ITEMS, ...IS_TAGS.map((t) => `⌂ ${t}`)];
  const doubled = [...row, ...row];

  return (
    <div
      data-testid="brand-marquee-container"
      className="relative bg-surface border-y border-white/10 py-5 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span
              className={`font-heading font-bold uppercase tracking-wider text-lg sm:text-xl px-6 ${
                item.startsWith("⌂") ? "font-mono text-sm text-gray-500" : "text-gray-200"
              }`}
            >
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-brand inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
